import { FormInstance } from "antd";
import { useCallback, useState } from "react";
import { usePrintHistory } from "../../hooks/usePrintHistory";

export const usePrint = (
  contractId: string,
  form: FormInstance,
  type: 0 | 1 | 2,
  close: () => void
) => {
  const [disabled, setDisabled] = useState<boolean>(false);

  const { printHistory } = usePrintHistory(setDisabled, close);

  const onPrint = useCallback(async () => {
    try {
      const values = await form.validateFields();

      setDisabled(true);

      const { dates, payerIds } = values;

      const request = {
        contractId,
        reportType: type,
        customerIds: payerIds || [],
        beginYear: dates[0].year(),
        endYear: dates[1].year(),
      };

      printHistory(request);
    } catch {
      setDisabled(false);
    }
  }, [form, contractId, type, printHistory]);

  return { onPrint, disabled };
};
